module.exports = __webpack_public_path__ + "static/media/auth-background-dark.992c4d7b.png";